import { Injectable } from '@angular/core';
import { ApiCommon } from '@shared/apis/common';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class Sc4uApi extends ApiCommon {

  getHrmErrors(serialNo: string, sc4uObjectId: string): Observable<any> {
    return this.apiServer.sc4u.getHrmErrors(serialNo, sc4uObjectId);
  }

  dialogEngineStart(sc4uObjectId: string, symptoms, text?): Observable<any> {
    const params = { sc4uObjectId, symptoms, text };
    return this.apiServer.sc4u.dialogEngineStart(params);
  }

  dialogEngine(sc4uObjectId, rootId, dialogId, dialogSymptom, index = 0, partIndices = [], parts = []): Observable<any> {
    const params = {
      sc4uObjectId,
      rootId,
      dialogId,
      dialogSymptom,
      index,
      partIndices,
      parts
    };
    return this.apiServer.sc4u.dialogEngine(params);
  }

  getInHomeRepairPrice(sc4uObjectId, symptoms, zipcode, parts?, ascNo?): Observable<any> {
    const params = {
      sc4uObjectId,
      symptoms,
      zipcode,
      parts,
      ascNo,
    };
    return this.apiServer.sc4u.getInHomeRepairPrice(params);
  }

  getCiPsRepairPrice(sc4uObjectId, serviceType, symptoms, zipcode, parts?): Observable<any> {
    const params = {
      sc4uObjectId,
      serviceType,
      symptoms,
      zipcode,
      parts
    };
    return this.apiServer.sc4u.getCiPsRepairPrice(params);
  }

}
